import React, {useContext, useState} from 'react';
import {colours, spacing} from '../../styles/Style';
import {GetGlobalTheme} from '../../Tools/DisplayTools';
import {Button} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import styled from 'styled-components/native';

const StatusWrap = styled.View`
  margin-horizontal: ${spacing.medium};
  justify-content: center;
`;
const StatusText = styled.Text`
  color: ${colours[GetGlobalTheme()].rowText};
`;

export const StatusElement = (props) => {
  const [text, setStatus] = useState('');
  const state = {text, setStatus};
  global.updateStatusText = (data) => {
    setStatus(data);
    setTimeout((data) => {
      if (data != state.text) {
        setStatus('');
      }
    }, 3000);
  };
  const statusState = useContext(statusContext);
  return (
    <StatusWrap>
      <statusContext.Provider value={state.text}>
        <StatusText>{state.text}</StatusText>
      </statusContext.Provider>
    </StatusWrap>
  );
};

export const statusContext = React.createContext('');
